const getters = {
  token: state => state.user.token,
  userInfo: state => state.user.userInfo,
  address: state => state.appointment.address,
  family: state => state.appointment.family,
  appointmentType: state => state.appointment.appointmentType,
}
export default getters
